"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const random_1 = __importDefault(require("random"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('r', (context, [type, min, max, digits]) => {
    if (type === 'int') {
        return random_1.default.int(parseInt(min), parseInt(max)).toString();
    }
    else if (type === 'float') {
        let f = random_1.default.float(parseFloat(min), parseFloat(max));
        if (digits) {
            return f.toFixed(parseInt(digits));
        }
        else {
            return f.toString();
        }
    }
    else {
        throw new Error(`Unknown random type: ${type}`);
    }
});
